import React, { useState, useEffect } from 'react';
import { validateFilename } from '../utils/filenameValidation';

const EditFileNameModal = ({ isOpen, onClose, currentName, onSave }) => {
  const [fileName, setFileName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [validationError, setValidationError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setFileName(currentName || '');
    }
  }, [isOpen, currentName]);

  const handleSave = async () => {
    if (!fileName.trim()) {
      setValidationError('Please enter a file name');
      return;
    }

    // Validate filename for knowledgebase compatibility
    const validation = validateFilename(fileName);
    if (!validation.isValid) {
      setValidationError(validation.error);
      return;
    }

    setValidationError('');
    setIsLoading(true);
    try {
      await onSave(fileName.trim());
      onClose();
    } catch (error) {
      console.error('Error saving file name:', error);
      alert('Failed to update file name');
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit File Name</h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
              disabled={isLoading}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label htmlFor="fileName" className="form-label">File Name</label>
              <input
                type="text"
                className={`form-control ${validationError ? 'is-invalid' : ''}`}
                id="fileName"
                value={fileName}
                onChange={(e) => {
                  setFileName(e.target.value);
                  setValidationError('');
                }}
                onKeyDown={handleKeyPress}
                disabled={isLoading}
                autoFocus
              />
              {validationError && (
                <div className="invalid-feedback">{validationError}</div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button 
              type="button" 
              className="btn btn-primary" 
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : 'Save'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditFileNameModal;
